import React from 'react';
import './DocListHolder.scss';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { MultipleTypesDocumentsUploader } from '../../../../../SharedComponents';
import { CheckboxesComponent } from '../../../../../Components';
import { TrackEventService } from '../../../../../Helper/mixpanelHelper';

export const DocListHolder = ({
  documents,
  onDocumentsChange,
  isDisabled,
  isWithoutCheckbox,
  headerText,
  haveToResetInitDOCs,
  parentTranslationPath,
  translationPath,
  Page,
}) => {
  const { t } = useTranslation(parentTranslationPath);

  const checkIsSignedOffChecked = () => documents?.length > 0;

  return (
    <div className='sign-off-container gap-20'>
      <div className='sign-off-header w-100'>
        <p className='fz-18 fw-simi-bold m-0'>
          {t(`${translationPath}${headerText}`)}
        </p>
        {!isWithoutCheckbox ? (
          <div
            className='sign-off-check'
            onMouseEnter={() => {
              if (headerText === 'Landlord-offer-letter') {
                TrackEventService(
                  'Leasing_journey_Offer_Letter_Dispatch_Landloard_Signed_Off_ Checked',
                  {
                    page_name: 'Leasing Journey',
                    screen: 'Offer Letter Dispatch',
                  }
                );
                TrackEventService(
                  'Leasing_journey_Offer_Letter_Dispatch_Landloard_Signed_Off_ Clicked',
                  {
                    page_name: 'Leasing Journey',
                    screen: 'Offer Letter Dispatch',
                  }
                );
              } else if (headerText === 'Contract-Issuance') {
                TrackEventService(
                  'Leasing_journey_Contact_Issuance_Landloard_Contract_Signed_Off__Clicked',
                  {
                    page_name: 'Leasing Journey',
                    screen: 'Offer Letter Dispatch',
                  }
                );
                TrackEventService(
                  'Leasing_journey_Contact_Issuance_landloard_Contract_Signed_Off_Checked',
                  {
                    page_name: 'Leasing Journey',
                    screen: 'Offer Letter Dispatch',
                  }
                );
              } else {
                TrackEventService(
                  'Leasing_journey_Offer_Letter_Dispatch_Tenant_Signed_Off_Clicked',
                  {
                    page_name: 'Leasing Journey',
                    screen: 'Offer Letter Dispatch',
                  }
                );
                TrackEventService(
                  'Leasing_journey_Offer_Letter_Dispatch_Tenant_Signed_Off_Checked',
                  {
                    page_name: 'Leasing Journey',
                    screen: 'Offer Letter Dispatch',
                  }
                );
              }
            }}
          >
            <CheckboxesComponent
              idRef='IsImportantRef'
              wrapperClasses='rounded'
              isDisabled
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              label='Signed-off'
              singleChecked={checkIsSignedOffChecked()}
              themeClass='theme-propx'
            />
          </div>
        ) : null}
      </div>
      <div className='w-100'>
        <MultipleTypesDocumentsUploader
          idRef='importFileRef'
          initUploadedFiles={documents || []}
          labelValue=''
          Page={Page}
          isDisabled={isDisabled}
          uploadedChanged={(documents) => onDocumentsChange(documents)}
          multiple
          theme='propx'
          isOpenGallery
          viewUploadedFilesCount={false}
          openGallery
          isDocuments
          haveToResetInitDOCs={haveToResetInitDOCs}
          checkIsRemoveHidden={(file) => !file?.type && !file.isUploaded}
        />
      </div>
    </div>
  );
};

DocListHolder.propTypes = {
  documents: PropTypes.array,
  onDocumentsChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  isWithoutCheckbox: PropTypes.bool,
  headerText: PropTypes.string,
  translationPath: PropTypes.string,
  parentTranslationPath: PropTypes.string,
};

DocListHolder.defaultProps = {
  documents: [],
  onDocumentsChange: () => {},
  isDisabled: false,
  isWithoutCheckbox: false,
  headerText: '',
  translationPath: '',
  parentTranslationPath: '',
};
